/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-14 09:25:32
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo } from 'src/types/base';
export declare namespace DataAuditDOI {
    export interface RowDataI {
        check_time: string;
        check_user: string;
        data_time: string;
        device_name: string;
        id: number;
        [str: string]: any;
    }

    export interface QueryRowDataParamsI extends PageDo {
        mn: string;
        start_time: string;
        end_time: string;
    }
    export interface DataDetailI {
        key: string;
        name: string;
        unit: string;
        average: string;
        effective_sample: number;
        maximum: string;
        minimum: string;
        data: { id: string; timestamp: number; [str: string]: any }[];
    }
}
export default class DataAuditApi {
    /**
     * 查询列表
     * @param {DataAuditDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchLog(
        params: DataAuditDOI.QueryRowDataParamsI,
    ): Promise<ResultPageDo<DataAuditDOI.RowDataI[], { key: string; name: string; unit: string }[]>> {
        return Api.post('/monitor/check_log/query', {
            start_time: '',
            end_time: '',
            ...params,
        });
    }
    // 获取全部无效标识集
    static async InvalidIdentifiersList(): Promise<Result<any>> {
        return Api.get('/monitor/check/invalid_identifiers/get');
    }
    // 新增无效标识集
    static async InvalidIdentifiersAdd(params: { code: string; name: string; priority_level: string }): Promise<Result<any>> {
        return Api.post('/monitor/check/invalid_identifiers/set', params);
    }
    // 删除无效标识集数组
    static async InvalidIdentifiersDelete(data: { ids: Array<number> }): Promise<Result<any>> {
        return Api.post('/monitor/check/invalid_identifiers/delete', data);
    }

    // 审核日历
    static async searchAudit(params: {
        mn: string;
        start_time: number;
        end_time: number;
    }): Promise<Result<{ data_time: string; check_status: string }[]>> {
        return Api.post('/monitor/calendar/check', params);
    }
    // 数据审核根据站点返回数据
    static async searchDataDetail(params: {
        mn: string;
        start_time: number;
        end_time: number;
    }): Promise<Result<DataAuditDOI.DataDetailI[]>> {
        return Api.post('/monitor/data/query/site', params);
    }
    // 根据站点审核数据
    static async audit(params: {
        device_name: string;
        mn: string;
        check_info: any;
        remark: string;
        flag: string;
        cause_id: number;
        cause: number;
        data_validity: boolean;
    }): Promise<Result<any>> {
        return Api.post('/monitor/data/check/site', params);
    }
    // TODO 根据审核时间和审核因子查询审核详情
    static async getCheckDetails(params: { timestamp: number; component: string; mn: string }): Promise<Result<any>> {
        return Api.post('/monitor/check/details/get', params);
    }

    static async getDeviceStatusRule(): Promise<Result<any>> {
        return Api.post('/monitor/data/device/status');
    }
    static async getQcStatusRule(): Promise<Result<any>> {
        return Api.post('/monitor/qc/status');
    }
    static async getLimit(): Promise<Result<any>> {
        return Api.post('/monitor/audit/limiting_value');
    }
    // 查询用户是否拥有审核权限
    static async getAuditActivity(): Promise<Result<any>> {
        return Api.post('/monitor/audit/permission');
    }
    // 自动审核是否开启
    static async changeAutoAudit(id: number, is_auto_audit: number): Promise<Result<any>> {
        return Api.post('/monitor/auto_audit/whether_participate', { id, is_auto_audit });
    }

    static async getAutoAuditStatus(mn: string): Promise<Result<any>> {
        return Api.post('/monitor/auto_audit/status/by/mn', { "mn": mn });
    }
}
